// TypeScriptファイル内でexportを利用していない場合は、export{};を定義
export {};
import iconv from "iconv-lite";

// 拡張メソッドの定義
declare global {
    interface String {
        /**
         * マルチバイトに変換したときのバイト数を取得します
         * @return 取得バイト数
         */
        getMultiBytesSize(): number;

        /**
         * 文字列を半角数字以外を取り除きます
         * @return 変換結果
         */
        removeNotHalfNumber(): string;

        /**
         * 文字列を半角数字の少数以外を取り除きます
         * @return 変換結果
         */
        removeNotHalfNumberDecimal(): string;

        /**
         * 文字列を半角英数字記号以外を取り除きます
         * @return 変換結果
         */
        removeNotHalfChar(): string;

        /**
         * 半角英数字、"."、"_" 以外を取り除きます
         * @return 変換結果
         */
        removeUnUsePackageNameChar(): string;

        /**
         * 文字列を半角英数字記号以外を取り除きます(※改行コードを許容します。)(※\tは除外します)
         * @return 変換結果
         */
        removeNotHalfCharAllowNewLine(): string;

        /**
         * 文字列に指定された文字が含まれるかチェックします
         * @param[in]   strSearchChars : 検索する文字群
         * @return true : 含まれる
         */
        includeChar(strSearchChars: string): boolean;

        /**
         * 文字列から制御文字を除外します(※\r \n \tも除外します)
         * @return 除外結果
         */
        removeControlCode(): string;

        /**
         * 文字列から制御文字を除外します(※改行コードを許容します。)(※\tは除外します)
         * @return 除外結果
         */
        removeControlCodeAllowNewLine(): string;

        /**
         * 文字列に制御コードが含まれるかチェックします
         * @return true : 含まれる
         */
        includeControlCode(): boolean;

        /**
         * 文字列に制御コードが含まれるかチェックします(※改行コードを許容します。)
         * @return true : 含まれる
         */
        includeControlCodeAllowNewLine(): boolean;

        /**
         * 文字列に全角文字列が含まれるかチェックします
         * @return true : 含まれる
         */
        includeFullChar(): boolean;

        /**
         * 文字列に半角文字列が含まれるかチェックします
         * @return true : 含まれる
         */
        includeHalfCharKANA(): boolean;

        /**
         * 文字列比較(ソート用)
         * @return -1 : this <  _obj
         * @return 0  : this == _obj
         * @return 1  : this >  _obj
         */
        compareSort(_obj: string): number;

        /**
         * csv出力用の文字列にを生成
         * @return csv出力用文字列
         */
        makeCsvItemEx(): string;

        /**
         * shift-jisで文字化けする文字を除外します
         * @return true : 除外結果
         */
        removeNotSJIS(): string;

        /**
         * shift-jisで文字化けする文字が含まれているか
         * @return true : 含んでいる
         */
        includeNotSJIS(): boolean;

        /**
         * メールアドレスが正しいかどうか
         * @return true : 正しい
         */
        isValidMailAddress(): boolean;

        /**
         * メールアドレスが正しいかどうか
         * @return true : 正しい
         */
        isValidMailAddress2(): boolean;

        /**
         * パッケージ名のフォーマットを満たすかどうか
         * @return true : 正しい
         */
        isValidPackageName(): boolean;

        /**
         * SKYSEA バージョン判定（アルファベットの判定は行っていません）
         * @return -1 : this <  _obj
         * @return 0  : this == _obj
         * @return 1  : this >  _obj
         * @return false : 引数エラー
         */
        compareScvVersion(_obj: string): number | boolean;

        /**
         * 箇条書きのエラーメッセージを作成します
         * @return string
         */
        createErrorsMessage(arErrorMessage: Array<string>): string;

        /**
         * HTMLの特殊文字をエスケープしたメッセージを作成します
         * @return string
         */
        escapeHtml(): string;

        /**
         * 特定の文字を取り除きます。
         * @return string
         */
        designString(strDesignText: string): string;

        /**
         * 簡易暗号(ロジックはばれるので重要な情報の暗号化には使わないでください)
         * @return string
         */
        easyEncrypt(): string;

        /**
         * 簡易復号(ロジックはばれるので重要な情報の暗号化には使わないでください)
         * @return string
         */
        easyDecrypt(text: string): string;

        /**
         * 半角スペースを取り除きます。
         * @return 変換結果
         */
        removeHalfSpaceChar(): string;

        /**
         * %sを指定された文字に置き換えます。
         * @return 変換結果
        */
        format(...args: string[]): string;
    }
}

// 拡張メソッドの実装

/**
 * マルチバイトに変換したときのバイト数を取得します
 * @return 取得バイト数
 */
String.prototype.getMultiBytesSize = function () {
    let length = 0;
    for (let i = 0; i < this.length; i++) {
        const c = this.charCodeAt(i);
        if ((c >= 0x0 && c < 0x81) || (c === 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
            length += 1;
        } else {
            length += 2;
        }
    }
    return length;
};

/**
 * 文字列を半角数字以外を取り除きます
 * @return 変換結果
 */
String.prototype.removeNotHalfNumber = function () {
    // 半角数字以外を取り除く
    return this.replace(/[^0-9]/g, '');
};

/**
 * 文字列を半角数字少数以外を取り除きます
 * @return 変換結果
 */
String.prototype.removeNotHalfNumberDecimal = function () {
    // 半角数字少数以外を取り除く
    return this.replace(/[^0-9\u002e]/g, '');
};

/**
 * 文字列を半角英数字記号以外を取り除きます
 * @return 変換結果
 */
String.prototype.removeNotHalfChar = function () {
    return this.replace(/[^\x01-\x7E]/g, '');
};

/**
 * 半角英数字、"."、"_" 以外を取り除きます
 * @return 変換結果
 */
String.prototype.removeUnUsePackageNameChar = function () {
    return this.replace(/[^a-zA-Z0-9._]/g, '');
};

/**
 * 文字列を半角英数字記号以外を取り除きます(※改行コードを許容します。)
 * @return 変換結果
 */
String.prototype.removeNotHalfCharAllowNewLine = function () {
    return this.replace(/[^\x01-\x7E\u000A\u000D]/g, '');
};

/**
 * 文字列に指定された文字が含まれるかチェックします
 * @param[in]   strSearchChars : 検索する文字群(サロゲートペア非対応)
 * @return true : 含まれる
 */
String.prototype.includeChar = function (strSearchChars: string) {

    for (let i = 0; i < strSearchChars.length; i++) {
        if (this.includes(strSearchChars.charAt(i))) {
            return true;
        }
    }
    return false;
};

/**
 * 文字列から制御文字を除外します(※\r \n \tも除外します)
 * @return true : 除外結果
 */
String.prototype.removeControlCode = function () {
    /* eslint no-control-regex: 0 */
    const pattern = /[\u0000-\u001F\u007F–\u00A0\u00AD]/g;   // ユニコード制御文字
    // メモ \r \n \r を除外したいなら、下記の正規表現でいけるはず
    // /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F–\u00A0\u00AD]/g

    return this.replace(pattern, '');
};

/**
* 文字列から制御文字を除外します(※改行コードを許容します。)(※\tは除外します)
* @return 除外結果
*/
String.prototype.removeControlCodeAllowNewLine = function () {
    /* eslint no-control-regex: 0 */
    const pattern = /[\u0000-\u0009\u000B\u000C\u000E-\u001F\u007F–\u00A0\u00AD]/g;   // ユニコード制御文字

    return this.replace(pattern, '');
};

/**
 * 文字列に制御コードが含まれるかチェックします
 * @return true : 含まれる
 */
String.prototype.includeControlCode = function () {
    /* eslint no-control-regex: 0 */
    const pattern = /[\u0000-\u001F\u007F–\u00A0\u00AD]/g;   // ユニコード制御文字

    return (this.match(pattern) !== null) ? true : false;
};

/**
 * 文字列に制御コードが含まれるかチェックします(※改行コードを許容します。)
 * @return true : 含まれる
 */
String.prototype.includeControlCodeAllowNewLine = function () {
    /* eslint no-control-regex: 0 */
    const pattern = /[\u0000-\u0009\u000B\u000C\u000E-\u001F\u007F–\u00A0\u00AD]/g;   // ユニコード制御文字

    return (this.match(pattern) !== null) ? true : false;
}

/**
 * 文字列に全角文字列が含まれるかチェックします
 * @return true : 含まれる
 */
String.prototype.includeFullChar = function () {
    /* eslint no-control-regex: 0 */
    const pattern = /[^\x01-\x7E\uFF61-\uFF9F]/g;   // 全角文字(半角でなく、半角カタカナでない)

    return (this.match(pattern) !== null) ? true : false;
}
/**
 * 文字列に半角カナ列が含まれるかチェックします
 * @return true : 含まれる
 */
String.prototype.includeHalfCharKANA = function () {
    /* eslint no-control-regex: 0 */
    const pattern = /[\uFF61-\uFF9F]/g;   // 半角カタカナ

    return (this.match(pattern) !== null) ? true : false;
}
/**
 * 文字列比較(ソート用)
 * @return -1 : this <  _obj
 * @return 0  : this == _obj
 * @return 1  : this >  _obj
 */
String.prototype.compareSort = function (_obj: string) {
    // 大文字、小文字は区別する
    if (this < _obj) {
        return -1;
    }
    if (this > _obj) {
        return 1;
    }

    return 0;
}

/**
 * csv出力用の文字列にを生成
 * @return csv出力用文字列
 */
String.prototype.makeCsvItemEx = function () {
    // ダブルクォーテーションが必要かチェック
    let isNeedQuote = false;
    for (let i = 0; i < this.length; i++) {
        const c = this.charCodeAt(i);
        if (
               0x0a == c    // LF
            || 0x0d == c    // CR
            || 0x2c == c    // カンマ
            || 0x22 == c    // ダブルクォーテーション
        ) {
            isNeedQuote = true;
            break;
        }
    }

    // ダブルクォーテーションが不要ならそのまま終了
    if (false == isNeedQuote) {
        return this.toString();
    }

    // ダブルクォートが必要なら囲った上でエスケープ処理
    return "\"" + this.replaceAll("\"", "\"\"") + "\"";
};

/**
 * shift-jisで文字化けする文字を除外します
 * @return true : 除外結果
 */
String.prototype.removeNotSJIS = function () {
    // utf-8をshijt-jis文字列に変換(normalize()しておかないと、結合文字「パ」が文字化けする)
    const sjisBuf = iconv.encode(this.normalize().toString(), "sjis");
    const sjisStr = iconv.decode(sjisBuf, "sjis");  // sjisに変換したときの表示内容をutf-8の文字列として格納
    
    return sjisStr;
}

/**
 * shift-jisで文字化けする文字が含まれているか
 * @return true : 含んでいる
 */
String.prototype.includeNotSJIS = function () {
    return this.removeNotSJIS() != iconv.encode(this.normalize().toString(), "utf-8").toString();
}

/**
 * メールアドレスが正しいかどうか
 * @return true : 正しい
 */
String.prototype.isValidMailAddress = function () {
    //「@」が含まれていない
    if (this.match("@") === null) {
        return false;
    }

    // 全体が 256文字 以上
    if (this.length >= 256) {
       return false;
    }

    // ローカルパート(@の前)が 0文字
    let nCount = 0;
    for (nCount; nCount <= this.length; ) {
        const c = this.charCodeAt(nCount);
        if (
            0x40 == c    // @
        ) {
            break;
        }
        else {
            ++nCount;
        }
    }

    if (nCount == 0) {
        return false;
    }

    ++nCount;

    // ドメインパート(@の後)が 0文字
    if (this.length - nCount == 0) {
       return false;
    }

    // ドメインパートが括弧（[ ]）を含むIP形式
    const reg = new RegExp(/@.*\[[0-9]+\.[0-9]+\.[0-9]+\.[0-9]+\]/);
    if (reg.test(this.toString())) {
        return false;
    }
    return true;
}

/**
 * メールアドレスが正しいかどうか(新)
 * @return true : 正しい
 */
String.prototype.isValidMailAddress2 = function () {
    // ローカルパート
    // 半角英数字(a-zA-Z0-9)、ドット（.）、プラス(+)、アンダーバー（_）、およびハイフン（-）を含むことができる
    // 厳密にはサービスに依存するが、GmailやOutlook.comを参考にして上記にしている。
    // ドットは最初や最後では使用できない、またドットを連続して使用できない
    // 
    // ドメインパート
    // 2つ以上のセグメントが必要
    // トップレベルドメイン(一番右)については 2文字以上かつ(a-zA-Z)
    // トップレベルドメイン以外は数字(0-9)やハイフン(-)も利用可
    // しかし、ハイフン(-)はラベルの先頭と最後では使用不可
    //
    // 補足
    // 文字数のmin/maxは機能要件に依存するので別の処理でみること
    // SaaS\Web\CtlSvr_Cloud\CtlSvr_Cloud\Models\Validaters\StringValidator.csと同等である必要がある
    const regex = /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
    const reg = new RegExp(regex);
    return reg.test(this.toString());
}

/**
 * パッケージ名のフィーマットを満たすかどうか
 * @return true : 正しい
 */
String.prototype.isValidPackageName = function () { 
    // It must have at least two segments (one or more dots).
    // 少なくとも2つのセグメント（1つ以上のドット）が必要です。
    //
    // Each segment must start with a letter.
    // 各セグメントは文字で始まる必要があります。
    //
    // All characters must be alphanumeric or an underscore [a-zA-Z0-9_].
    // すべての文字は英数字またはアンダースコア（a-zA-Z0-9_）である必要があります。
    const regex = /^[a-zA-Z][a-zA-Z0-9_]*\.[a-zA-Z][a-zA-Z0-9_]*(\.[a-zA-Z][a-zA-Z0-9_]*)*$/;
    const reg = new RegExp(regex);
    return reg.test(this.toString());
}

/**
 * SKYSEA バージョン判定（アルファベットの判定は行っていません）
 * @return -1 : this <  _obj
 * @return 0  : this == _obj
 * @return 1  : this >  _obj
 */
String.prototype.compareScvVersion = function (_obj: string) {
    // フォーマットチェック
    const reg = new RegExp(/^[0-9]+\.[0-9][0-9][0-9]\.[0-9]+.*/);
    if (!reg.test(this.toString())) {
        return false;
    }
    if (!reg.test(_obj)) {
        return false;
    }

    const srcVersionArray = this.split(".");
    const objVersionArray = _obj.split(".");

    // メジャーバージョン
    let srcVer = parseInt(srcVersionArray[0]);
    let objVer = parseInt(objVersionArray[0]);
    if (srcVer < objVer) {
        return -1;
    }
    else if (srcVer > objVer) {
        return 1;
    }

    // マイナーバージョン
    srcVer = parseInt(srcVersionArray[1]);
    objVer = parseInt(objVersionArray[1]);
    if (srcVer < objVer) {
        return -1;
    }
    else if (srcVer > objVer) {
        return 1;
    }

    // ビルドバージョン（
    srcVer = parseInt(srcVersionArray[2]);
    objVer = parseInt(objVersionArray[2]);
    if (srcVer < objVer) {
        return -1;
    }
    else if (srcVer > objVer) {
        return 1;
    }

    return 0;
}

/**
 * 箇条書きのエラーメッセージを作成します
 * @return string
 */
String.prototype.createErrorsMessage = function (arErrorMessage: Array<string>) {
    const len = arErrorMessage.length;
    if (0 == len) {
        return "";
    }
    else if (1 == len) {
        // 一つなら・なし
        return arErrorMessage[0];
    }
    else {
        // 複数なら・あり
        let strRet = "・" + arErrorMessage[0];
        for (let i = 1; i < len; i++) {
            strRet += "<br />・" + arErrorMessage[i];
        }
        return strRet;
    }
}

/**
 * HTMLの特殊文字をエスケープしたメッセージを作成します
 * @return string
 */
String.prototype.escapeHtml = function () {

    // HTMLの特殊文字のエスケープを用意
    interface escapeKey {
        [key: string]: string
    }
    const patterns: escapeKey = {
        '<'  : '&lt;',
        '>'  : '&gt;',
        '&'  : '&amp;',
        '"'  : '&quot;',
        '\'' : '&#x27;',
        '`'  : '&#x60;'
    };

    return this.replace(/[<>&"'`]/g, function (match) {
        return patterns[match];
    });
}

/**
 * 特定の文字を取り除きます。
 * @return string
 */
String.prototype.designString = function (strDesignText: string) {

    //文字列を元に正規表現オブジェクトを生成する
    const reObj = new RegExp("[^" + strDesignText + "]", "g");  

    // 指定した文字を取り除く
    return this.replace(reObj, '');
}

/**
 * 簡易暗号(ロジックはばれるので重要な情報の暗号化には使わないでください)
 * @return string
 */
String.prototype.easyEncrypt = function () {

    const text = this as string;
    const e1 = window.btoa(window.encodeURIComponent(text));
    const alphabets = "cBu4UeHf+RFgzOXhlDJn72aoPTLrq5wvj3Yx8VCEi6GtIb0k9NKmydSp=W/MsZ1AQ".split("");
    const max = alphabets.length - 1;
    const c2 = new Array(0);
    e1.split("").map((t) => {
        const index = (alphabets.indexOf(t) === max) ? 0 : alphabets.indexOf(t) + 1;
        c2.push(alphabets[index]);
    });

    return c2.join("");
}

/**
 * 簡易復号(ロジックはばれるので重要な情報の暗号化には使わないでください)
 * @return string
 */
String.prototype.easyDecrypt = function() {
    const text = this as string;
    const alphabets = "cBu4UeHf+RFgzOXhlDJn72aoPTLrq5wvj3Yx8VCEi6GtIb0k9NKmydSp=W/MsZ1AQ".split("");
    const max = alphabets.length - 1;
    const d2 = new Array(0);
    text.split("").map((t) => {
        const index = (alphabets.indexOf(t) === 0) ? max : (alphabets.indexOf(t) - 1);
        d2.push(alphabets[index]);
    });
    return decodeURIComponent(window.atob(d2.join("")));
}

/**
 * 半角スペースを取り除きます。
 * @return 変換結果
 */
String.prototype.removeHalfSpaceChar = function () {
    return this.replace(/ /g, "");
};

/**
 *  %sを指定された文字に置き換えます。 
 * @param args 置き換える文字列
 * @return 変換結果
 */
String.prototype.format = function (...args: string[]) {
    return this.replace(/%s/g, () => args.shift() || '');
};


